// **  Initial State
const initialState = {
    allData: [],
    selected: null
}

const categoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_CATEGORIES':
            return { ...state, allData: action.data }
        case 'ADD_CATEGORY':
            return { ...state, allData:[...state.allData.concat(action.data)]  }
        case 'SELECTED_CATEGORY':
            return { ...state, selected: action.data }
        case 'UPDATE_CATEGORY':
            return {
                ...state,
                allData: [
                    ...state.allData.filter(category => category.id !== action.data.id),
                    action.data
                ]
            }
        case 'DELETE_CATEGORY':
            return {
                ...state,
                allData: state.allData.filter(category => {return category.id !== action.data.deleteitems} )
            }
        default:
            return state
    }
}

export default categoryReducer
